module.exports = __webpack_public_path__ + "static/media/Group9108.8f38a258.svg";